export default __webpack_public_path__ + "static/media/neon_donut@3x.0c57aa55.png";